goog.provide('el8.appchart.providers.search');

goog.require('el8.app.shared.network.viewEditConnection');
goog.require('el8.appchart.mgr.thirdpane');
goog.require('el8.data.specialtyCategories');
goog.require('el8.model.base');
goog.require('el8.ptdata.ptProviders');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.providers');
goog.require('el8.util.consts');


/**
 * This file is used by el8.appchart.providers.main
 * and handles the search tab
 */
el8.appchart.providers.search = (function() {

    var _filteredSpec = {}; /* stores a categoryId or name if we're currently filtered */

    var container = $('#fourth-pane');
    var $searchSection = null;

    var that = {};

    $.extend(that, {

        doFilter: function(spec) {

            $searchSection = $('.provider-search-section', container);

            if (el8.appchart.providers.main.getShowingTab() !== 'search' && !spec.noTabChange) {
                el8.appchart.providers.main.showTab('search');
            }

            spec = spec || {};
            var isAuto = (spec.isAuto === true); // defaults false

            _filteredSpec = {};
            if (!el8.util.isNone(spec.categoryId)) {
                _filteredSpec.categoryId = spec.categoryId;
                if (isAuto) {
                    var categoryName = el8.data.specialtyCategories.getNameById(spec.categoryId);
                    setFilterVal(categoryName);
                }
            } else if (spec.name) {
                _filteredSpec.name = spec.name;
            } else {
                return;
            }

            el8.appchart.providers.main._destroyTooltips($searchSection);

            var addlFilters = extractAddlFilters();
            var soyMap = getFilterSoyMap(_filteredSpec, addlFilters);
            soyMap.collaboratorPractices = el8.ptdata.plrCollaborators.getPracticeIds();

            $('.provider-search-results', $searchSection).html(
                el8.template.appchart.providers.searchSection(soyMap)
            );
            // we'll need an addnl call to this in renderNetworkResult after the ajax call returns
            el8.appchart.providers.main._postRenderFn($searchSection);

            var $results = $('.fetch-connections-results', $searchSection);
            renderNetworkResults($results, soyMap.list.length, addlFilters);

            $('.reveal-post-search', $searchSection).show();

        },

        // if you just want to re-render/re-order the on-team list
        onTeamRearrange: function() {
            // we need to refresh just the local search portion
            if (!_filteredSpec.name && !_filteredSpec.categoryId) { return; }

            var $localResults = $('.local-results', $searchSection);
            var addlFilters = extractAddlFilters();
            var soyMap = getFilterSoyMap(_filteredSpec, addlFilters);
            soyMap.collaboratorPractices = el8.ptdata.plrCollaborators.getPracticeIds();

            $localResults.html(
                el8.template.appchart.providers.providerList(soyMap)
            );
            el8.appchart.providers.main._postRenderFn($localResults);
        },

        // if you either want to redo the current search or reset
        refreshContents: function() {
            if (!_.isEmpty(_filteredSpec)) {
                that.doFilter(
                    $.extend({
                        isAuto: true,
                        noTabChange: true
                    }, _filteredSpec)
                );
            } else {
                that.resetRender();
            }
        },
        // if you definitely want to reset
        resetRender: function() {
            setFilterVal('');
            $('.provider-search-results', $searchSection).html(
                el8.template.appchart.providers.searchCategories({
                    specialtyCategories: el8.data.specialtyCategories.allAsSoyMaps()
                })
            );
            _filteredSpec = {};
        },

        resetVars: function() {
            _filteredSpec = {};
            $searchSection = null;
        }

    });


    /* Core Internal Function: bind triggers, query, and render */
    function renderNetworkResults($results, numTeamMembers, addlFilters) {

        /* If we have a Physician, return its ID; if we have a
         * Canonical/NPI, create a Physician, then return its ID.
         * When we create a Physician, replace the ID in $idElt with the new ID */

        var waitingOnServer = false;
        var forcePhysicianType = function($idElt) {
            var id = $idElt.data('id');
            if (el8.model.idToModelClass(id) === 'Physician') { return id; }

            // avoid duplicate calls to physicianFromNpi/physicianFromCanonical
            // (returning may take longer than the double-click debounce rate)
            if (waitingOnServer) { return; }
            waitingOnServer = true;

            var newPhysician;
            var serverErrorFn = function() { waitingOnServer = false; };
            if (el8.model.idToModelClass(id) === 'CanonicalPhysician') {
                // have CanonicalPhysician, in this case an Elation user in a different practice
                newPhysician = el8.data.physicians.physicianFromCanonical(id, {
                    errorCb: serverErrorFn
                });
            } else {
                // have result from NPI
                newPhysician = el8.data.physicians.physicianFromNpi(id, {
                    errorCb: serverErrorFn
                });
            }
            waitingOnServer = false;
            var newId = newPhysician.getId();
            $idElt.data('id', newId);
            return newId;
        };
        // most of the triggers store the ID here
        var getIdFromConnectionTrigger = function($this) {
            var $connection = $this.closest('.connection-entry');
            return forcePhysicianType($connection);
        };

        $results.on('click', '.connection-write-message-trigger',  _.debounce(function() {
            var id = getIdFromConnectionTrigger($(this));
            var physician = el8.data.physicians.getById(id);
            if (physician && physician.getAccessUserId()) {
                el8.appshared.message.prePopulateNewMessage({
                    toUsers: [el8.data.practiceUsers.getById(physician.getAccessUserId())]
                });
            }
            el8.appchart.providers.main.hide();
        }, el8.util.consts.DOUBLE_CLICK_RATE, true));

        $results.on('click', '.connection-name-trigger',  _.debounce(function() {
            var id = getIdFromConnectionTrigger($(this));
            el8.app.shared.network.viewEditConnection.show({
                contactId: id,
                callbackFn: function(connection) {
                    that.refreshContents();
                }
            });

        }, el8.util.consts.DOUBLE_CLICK_RATE, true));

        $results.on('click', '.connection-write-letter-trigger',  _.debounce(function() {
            var id = getIdFromConnectionTrigger($(this));
            el8.appchart.providers.main.hide();
            el8.appchart.mgr.thirdpane.setLetterContact(id, 'provider-search');
        }, el8.util.consts.DOUBLE_CLICK_RATE, true));

        $results.on('click', '.connection-write-referral-trigger',  _.debounce(function() {
            var id = getIdFromConnectionTrigger($(this));
            el8.appchart.mgr.thirdpane.setReferralLetterContact(id, 'provider-search');

            el8.appchart.providers.main.hide();
        }, el8.util.consts.DOUBLE_CLICK_RATE, true));

        $results.on('click', '.connection-add-main-trigger',  _.debounce(function() {
            var id = getIdFromConnectionTrigger($(this));
            addPhysicianToMain(id);
        }, el8.util.consts.DOUBLE_CLICK_RATE, true));

        $results.addClass('el8Loading');
        var url, includeSpecialty;
        if (_filteredSpec.categoryId) {
            url = el8.service.urls.get('connectionsByCategory', [_filteredSpec.categoryId]);
            includeSpecialty = false;
        } else {
            url = el8.service.urls.get('connectionsByName');
            addlFilters.name = _filteredSpec.name;
            includeSpecialty = true;
        }
        $.el8_ajax({
            url: url,
            data: addlFilters,
            success: function(data) {

                $results.removeClass('el8Loading');

                var networkResults = data.in_network;
                var npiResults = data.out_of_network;

                /* First, remove any physicians that are already in Provider List */
                var idMap = el8.ptdata.ptProviders.getPhysicianIdMap();
                var npiMap = el8.ptdata.ptProviders.getPhysicianNpiMap();
                networkResults = _.reject(networkResults, function(d) { return idMap[d.id]; });
                npiResults = _.reject(npiResults, function(d) { return npiMap[d.npi]; });
                idMap = null;
                npiMap = null;

                /* Then go through and add is_practice_user flags as needed */
                _.each(networkResults, function(item) {
                    if (item.public_access_user_id && el8.data.practiceUsers.isMember(item.public_access_user_id)) {
                        item.is_practice_user = true;
                        item.provider_logo = 'emr'; // if they're in our practice, we know they're an EMR user...
                    }
                });

                /* Then render... */
                $results.html(
                    el8.template.appchart.providers.connectionResults({
                        numTeamMembers: numTeamMembers,
                        includeSpecialty: includeSpecialty,
                        networkResults: networkResults,
                        npiResults: npiResults
                    })
                );
                el8.appchart.providers.main._postRenderFn($results);
            }
        });

    }

    /* Smaller helpers */
    function setFilterVal(val) {
        $(':input[name="filterSpecialty"]', $searchSection).val(val);
    }

    // Used to render either a single specialty category ID or results for a name search
    function getFilterSoyMap(filterSpec, addlFilters) {
        if (filterSpec.categoryId) {
            return {
                list: el8.ptdata.ptProviders.getBySpecialtyCategoryId(filterSpec.categoryId, true, addlFilters)
            };
        } else if (filterSpec.name) {
            return {
                list: el8.ptdata.ptProviders.getByName(filterSpec.name, true, addlFilters)
            };
        }

        return {};
    }

    // Read city/state out of the input fields and return a filters dict
    function extractAddlFilters() {
        var addlFilters = {};
        var cityFilter = $('.city-filter', $searchSection).val();
        var stateFilter = $('.state-filter', $searchSection).val().toUpperCase();
        if (cityFilter) { addlFilters.city = cityFilter; }
        if (stateFilter) { addlFilters.state = stateFilter; }
        return addlFilters;
    }

    // Take a physician id and create a new ptProvider in the main group
    // then refresh the search to show the new provider
    function addPhysicianToMain(physicianId, successCb) {
        el8.ptdata.ptProviders.createMainProvider({
            physicianId: physicianId,
            successCb: function(provider) {
                el8.ptdata.ptProviders.trigger('MOVED_MAIN', provider.getId());
                if (successCb) { successCb(provider); }
            }
        });
    }


    return that;

})();
